<template>
  <div>
    <div :class="s.wrap">

    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'message-template',
  props: ['data'],
  data() {
    return {

    };
  },
  created() {
    this.getMessageTemplate();
  },
  computed: {
    ...mapState(['helper', 'user']),
  },
  methods: {
    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },

    /** ローディング終了 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },

    getMessageTemplate() {
      const params = {
        flags: [1],
        officeId: this.user.offices[0]?.id,
      };
      this.axios({
        method: 'GET',
        url: '/v1/messageTemplate/get/list',
        params,
      })
        .then((response) => {
          const res = response.data;
          console.log(res);
        })
        .catch((error) => {
          console.log(error);
          alert('エラーが発生しました。再度お試しください。');
        });
    },

  },
};
</script>
<style lang="scss" module="s">
.wrap {
  padding: 10px 15px;
}
.buttons {
  height: 100%;
  text-align: center;
  > * {
    border: none;
    background-color: transparent;
    padding: 0 16px;
    margin: 8px 4px 0;
    height: 100%;
    font-weight: bold;
    border-radius: 4px;
    &.mt_0 {
      margin-top: 0;
    }
    &.blue {
      background-color: var(--primary-blue);
      color: white;
    }
    &.gray {
      background-color: var(--bs-gray);
      color: white;
    }
    &.green {
      background-color: #20C997;
      color: white;
    }
    &:disabled {
      opacity: 0.5;
    }
  }
}
</style>
